<template>
  <div class="w-full max-w-xl py-20 bg-white flex flex-col space-y-20">
    <h2>{{ $t('rewards.send_to_different_address') }}</h2>
    <Card class="p-30 space-y-20">
      <legend class="font-semibold pb-20">
        {{ $t('rewards.reward_confirmation.sending_to') }}
      </legend>
      <Form
        :validator="$v.model"
        :error="error"
        :messages="{
          minLength: $t('registration.contact_info.length_error'),
        }"
      >
        <FormInput
          v-model="model.address"
          class="w-full"
          :label="$t('registration.contact_info.email')"
          name="address"
          :placeholder="$t('registration.contact_info.email_place_holder')"
          autocomplete="email"
        />
      </Form>
      <div class="text-grey-500 text-sm mt-10">
        {{ $t('common.does_not_change_contact_info') }}
      </div>
    </Card>
    <div class="mx-auto flex-shrink-0 space-y-20 flex flex-col justify-center">
      <HMButton
        :disabled="isFetching.update"
        padding="wide"
        @click="onComplete"
      >
        {{ $t('common.confirm') }}
      </HMButton>
      <HMButton color="white" outlined padding="wide" @click="promptCancel">
        {{ $t('common.cancel_btn') }}
      </HMButton>
    </div>
    <Modal :active="showModal" @close="closeAndResume">
      <FormExitModal
        :strings="exitModal"
        @confirm="closeAndCancel"
        @cancel="closeAndResume"
      />
    </Modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { required, email } from 'vuelidate/lib/validators'
import Card from '@components/common/card/Card'
import Form from '@components/common/forms/Form'
import FormExitModal from '@components/common/forms/FormExitModal'
import FormInput from '@components/common/forms/FormInput'
import Modal from '@components/common/Modal'

export default {
  components: {
    Card,
    Form,
    FormExitModal,
    FormInput,
    Modal,
  },
  props: {
    exitModal: {
      type: Object,
      default: () => {
        return {
          exitTitle: '',
          exitDescription: '',
          exitConfirm: '',
          exitCancel: '',
        }
      },
    },
  },
  data() {
    return {
      model: {
        address: '',
      },
      error: null,
      showModal: false,
    }
  },
  validations: {
    model: {
      address: { required, email },
    },
  },
  computed: {
    ...mapGetters('member', ['memberInfo', 'isFetching']),
  },
  methods: {
    onComplete() {
      this.error = null
      this.$v.$touch()
      if (this.$v.$invalid) return

      this.$emit('continue', { ...this.model })
    },
    promptCancel() {
      this.showModal = true
    },
    closeAndCancel() {
      this.$emit('cancel')
      this.showModal = false
    },
    closeAndResume() {
      this.showModal = false
    },
  },
}
</script>
<style></style>
